// extracted by css-extract-rspack-plugin
export default {"claimLink":"MwshmF74ILAPS0v7"};